import React from 'react'
import AccountFlow from 'js/components/AccountFlow/AccountFlow'
import Header from './Header'
import Features from './Features'
import Logo from '../../components/Logo'
import { getSessionItem } from '../../storeManager'

export default function GympassSignup() {
  const gympassUserInfo = getSessionItem('gympassUserInfo')
    ? JSON.parse(getSessionItem('gympassUserInfo') as string)
    : null

  const initialUserData = gympassUserInfo
    ? {
        firstName: gympassUserInfo.firstName,
        email: gympassUserInfo?.email,
      }
    : undefined

  return (
    <div className="bg-BgSub">
      <div className="bg-Bg px-20">
        <Header />
      </div>
      <AccountFlow
        onlySignup={true}
        scenario="gympass"
        initialUserData={initialUserData}
        // typescript workaround until AccountFlow is converted to typescript
        initialPlan={undefined}
      />
      <div className="mx-auto mt-96 max-w-1440 px-20">
        <Features />
      </div>
      <div className="py-64 text-center">
        <Logo />
      </div>
    </div>
  )
}
